import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, AppBar, Toolbar, IconButton, Typography, Box, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';

import LeaveBalanceEntry from './LeaveBalanceEntry';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import CustomTableContainer from '../../../Layout/CustomTableContainer';


const LeaveBalanceForm = ({ handleBackWinderMachineEntry }) => {
    // States to manage form data
    
    const [leaveBalanceData, setLeaveBalanceData] = useState([]);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [SelectedEmployeeleaveBalance, setSelectedEmployeeleaveBalance] = useState([]);


    useEffect(() => {
        fetchPendingRequests();
    }, []);

    const fetchPendingRequests = async () => {
        const companyid = localStorage.getItem('companyid');

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLeaveBalanceList, 'POST', { 'Content-Type': 'application/json' }, companyid)
            .then(data => {
                if (data?.length) {
                    setLeaveBalanceData(data);
                }
            })
            .catch(error => alert(error.message));
    };


   
    const [newLeaveBalance, setNewLeaveBalance] = useState(false);
    const [LeaveBalanceList, setLeaveBalanceList] = useState(true);

    const handleOpenLeaveBalanceEntry = () => {
        setNewLeaveBalance(true);
        setLeaveBalanceList(false);
        setSelectedEmployeeleaveBalance([]);

    }

    const handleOpenLeaveBalanceList = () => {
        setNewLeaveBalance(false);
        setLeaveBalanceList(true);
        fetchPendingRequests();

    }


    const handleEditLeaverBalance = (request) => {
        setNewLeaveBalance(true);
        setLeaveBalanceList(false);

        setSelectedEmployeeleaveBalance([request]);
    }


    return (
        <div>
            {LeaveBalanceList && (
                <>
                    <AppBar position="static" sx={{ backgroundColor: "inherit" }}>
                        <Toolbar>
                            <Typography variant='h4'>Employees Leave balance List </Typography>
                            <Button size="small" startIcon={<AddIcon />} variant="contained" color="secondary" onClick={handleOpenLeaveBalanceEntry} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>
                            <IconButton>
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackWinderMachineEntry} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box
                        gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '82vh', // Large devices (desktops)
                                xl: '86vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }

                        }}>
                        <CustomTableContainer colors={colors} >
                            <TableContainer  >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Employee Name</TableCell>
                                            <TableCell>Leave Type</TableCell>
                                            <TableCell>Allocated Days</TableCell>
                                            <TableCell>Used Days</TableCell>
                                            <TableCell>Remaining Days</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {leaveBalanceData.map((item, index) => (
                                            <TableRow key={index}>

                                                <TableCell> <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleEditLeaverBalance(item)}
                                                >
                                                    {item.employee_name}
                                                </span></TableCell>

                                                <TableCell>{item.leave_type}</TableCell>
                                                <TableCell>{item.allocated_days}</TableCell>
                                                <TableCell>{item.used_days}</TableCell>
                                                <TableCell>{item.remaining_days}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CustomTableContainer>
                    </Box>
                </>
            )}


            {newLeaveBalance && (
                <LeaveBalanceEntry handleOpenLeaveBalanceList={handleOpenLeaveBalanceList} SelectedEmployeeleaveBalance={SelectedEmployeeleaveBalance} />

            )}
        </div>
    );
};

export default LeaveBalanceForm;
